/* eslint-disable jsx-a11y/no-distracting-elements */
import React from "react";
import style from "./contact.module.css";
import { MdLocationOn, MdPhoneInTalk } from "react-icons/md";
import { IoMailOpen } from "react-icons/io5";
import { GrLanguage } from "react-icons/gr";
import axios from "axios";
import { useEffect, useState } from "react";
import {
  API_AUTH_PASSWORD,
  API_AUTH_USERNAME,
  API_BASE_URL,
  ADMIN_ID,
} from "../../Constant/Global";
import Loader from "../../components/loader/Loader";
import { Link } from "react-router-dom";

const Contact = () => {
  const [contactData, setContactData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // contact api

  const handleContactData = async () => {
    try {
      const finalData = { admin_id: ADMIN_ID };
      // console.log("finalData", finalData);
      const response = await axios.post(
        API_BASE_URL + "web/contact_us",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      // console.log("contact response", response.data.data);
      setIsLoading(false);
      setContactData(response.data.data);
    } catch (error) {
      console.log(error.response);
    }
  };

  useEffect(() => {
    handleContactData();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div
          className={`container-fluid ps-0 pe-0 ${style.scheme_container_fluid}`}
        >
          {/* Schemes row */}
          <div className={`row ${style.contact_row}`}>
            <header className={`${style.schemes_top_common_title_sec}`}>
              <span className={`${style.emergency_c_span_title}`}>
                Let’s Talk
              </span>
              <h5 className={`${style.emergency_bottom_title}`}>
                Whether you’re looking for a demo, have a support question or a
                business query get in touch.
              </h5>
            </header>
            <div className={`col-lg-7 ${style.contact_map_col}`}>
              <div className={`${style.contact_map_sec}`}>
                <iframe
                  src={contactData?.contact_us?.map_url}
                  style={{ border: "none", width: "100%", height: "100%" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="contact-map"
                ></iframe>
              </div>
            </div>
            <div className="col-lg-5">
              <div className={`${style.contact_details_sec}`}>
                <div className={`${style.contact_details_top}`}>
                  <h6 className={`${style.contact_det_title}`}>Contact us</h6>
                  <p className={`${style.contact_det_dec}`}>
                    Get in touch and let us know how we can <br /> help. Fill
                    out the form and we’ll be in touch as soon as possible.
                  </p>
                </div>
                <ul className={`${style.contact_details_bottom}`}>
                  <li className={`${style.contact_bottom_list}`}>
                    <div className={`${style.contact_list_icons_box}`}>
                      <MdLocationOn />
                    </div>{" "}
                    <span className={`${style.contact_bottom_list_text}`}>
                      {" "}
                      {contactData?.contact_us?.address}
                    </span>
                  </li>
                  <li className={`${style.contact_bottom_list}`}>
                    <div className={`${style.contact_list_icons_box}`}>
                      <MdPhoneInTalk />
                    </div>{" "}
                    <Link
                      to={`tel:${contactData?.contact_us?.mobile}`}
                      className={`${style.contact_bottom_list_text}`}
                    >
                      {" "}
                      {contactData?.contact_us?.mobile}
                    </Link>
                  </li>
                  <li className={`${style.contact_bottom_list}`}>
                    <div className={`${style.contact_list_icons_box}`}>
                      <IoMailOpen />
                    </div>{" "}
                    <Link
                      to={`mailto:${contactData?.contact_us?.email}`}
                      className={`${style.contact_bottom_list_text}`}
                    >
                      {" "}
                      {contactData?.contact_us?.email}
                    </Link>
                  </li>
                  <li className={`${style.contact_bottom_list}`}>
                    <div className={`${style.contact_list_icons_box}`}>
                      <GrLanguage />
                    </div>{" "}
                    <Link
                      to={contactData?.contact_us?.website_link}
                      target="_blank"
                      className={`${style.contact_bottom_list_text}`}
                    >
                      {" "}
                      {contactData?.contact_us?.website_link}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Contact;
